import { ApiError } from '@anm/api';
import ErrorAlert from '@anm/components/errors/ErrorAlert';
import { FC } from 'react';

import withVideoFolder, {
  WithVideoFolder
} from '../../../../HOCs/withVideoFolder';

type HOCs = WithVideoFolder;
export type VideoFolderErrorsProps = {};

const folderAlreadyExist = {
  title: 'A folder with this name already exists',
  description:
    'Please choose a different name or delete the existing one first.'
};

const errorMessageMap = {
  moveFolder: {
    400: folderAlreadyExist
  },
  renameFolder: {
    400: folderAlreadyExist
  }
};

type ErrorMessage = typeof errorMessageMap;
type StatusCode = keyof ErrorMessage[keyof ErrorMessage];

const mapErrorMessage = <T extends keyof ErrorMessage, K extends StatusCode>(
  name: T,
  error: ApiError
) => ({ ...error, message: errorMessageMap[name][error.code as K] });

const VideoFolderErrors: FC<HOCs & VideoFolderErrorsProps> = ({
  videoFolder: { moveFolder, renameFolder }
}) => {
  return (
    <>
      {(moveFolder.error || moveFolder.isPending) && (
        <ErrorAlert
          isPending={moveFolder.isPending}
          error={
            moveFolder.error && mapErrorMessage('moveFolder', moveFolder.error)
          }
        />
      )}

      {(renameFolder.error || renameFolder.isPending) && (
        <ErrorAlert
          isPending={renameFolder.isPending}
          error={
            renameFolder.error &&
            mapErrorMessage('renameFolder', renameFolder.error)
          }
        />
      )}
    </>
  );
};

export default withVideoFolder(VideoFolderErrors);
